import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import settingsService from "../../Api/settings";

const initialState = {
  exchangeCommonSettings: [],
  languageList: [],
  currencySettings: [],
  isLoading: false,
  isSuccess: false,
  isError: false,
  error: null,
  tradingPairStats: {
    latestTradePrice: null,
  },
};

export const getSettings = createAsyncThunk(
  "get/exchange_settings",
  async (_, thunkAPI) => {
    try {
      return await settingsService.getSettings();
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getLanguageList = createAsyncThunk(
  "get/language_list",
  async (_, thunkAPI) => {
    try {
      return await settingsService.getLanguageList();
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getCurrencySettings = createAsyncThunk(
  "get/currency_settings",
  async (_, thunkAPI) => {
    try {
      return await settingsService.getCurrencySettings();
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

const exchangeSlice = createSlice({
  name: "exchange",
  initialState,
  reducers: {
    setLatestTradePrice: (state, action) => {
      state.tradingPairStats.latestTradePrice = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getSettings.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
        state.isError = false;
        state.error = null;
      })
      .addCase(getSettings.fulfilled, (state, action) => {
        state.exchangeCommonSettings = action?.payload;
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.error = null;
      })
      .addCase(getSettings.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.error =
          action?.payload?.code === "ERR_NETWORK"
            ? action?.payload?.message
            : action?.payload?.response?.data?.message;
      })
      .addCase(getLanguageList.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
        state.isError = false;
        state.error = null;
      })
      .addCase(getLanguageList.fulfilled, (state, action) => {
        state.languageList = action?.payload;
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.error = null;
      })
      .addCase(getLanguageList.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.error =
          action?.payload?.code === "ERR_NETWORK"
            ? action?.payload?.message
            : action?.payload?.response?.data?.message;
      })
      .addCase(getCurrencySettings.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
        state.isError = false;
        state.error = null;
      })
      .addCase(getCurrencySettings.fulfilled, (state, action) => {
        state.currencySettings = action?.payload;
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.error = null;
      })
      .addCase(getCurrencySettings.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.error =
          action?.payload?.code === "ERR_NETWORK"
            ? action?.payload?.message
            : action?.payload?.response?.data?.message;
      });
  },
});

export const { setLatestTradePrice } = exchangeSlice.actions;
export default exchangeSlice.reducer;
